import { PrismicRichText } from "@prismicio/react";
import React from "react";
import { Tooltip } from "react-tooltip";

export const ListThree = (props) => {
  const number = props.number;

  const sc = props.slice.primary;

  const cat = props.cat;

  const theme = (number) => {
    switch (number) {
      case 0:
        return sc.comp_one_theme;
      case 1:
        return sc.comp_two_theme;
      case 2:
        return sc.comp_three_theme;
    }
  };

  const richText = (number) => {
    switch (number) {
      case 0:
        return sc.comp_one.richText;
      case 1:
        return sc.comp_two.richText;
      case 2:
        return sc.comp_three.richText;
    }
  };

  return (
    <div className="feature">
      <div className="flex flex-wrap gap-2 justify-between items-center">
        <div className={"title text-2xl font-bold mb-4 text-" + theme(number)}>
          <PrismicRichText field={richText(number)} />
        </div>
      </div>
      <ul className="th">
        {cat.map((f, index) => {
          if ((number === 0 && f.comp_one === true) || (number === 1 && f.comp_two === true) || (number === 2 && f.comp_three === true)) {
            return (
            f.feature ? (
                <li
                key={index}
                className="border-t border-grey-light py-3 text-sm"
              >
                <div className="flex items-center">
                  <i className="text-xl fa-solid fa-check mr-4 text-accessible-green" />{" "}
                  {f.feature}
                  {f.tooltip ? (
                    <a
                      data-tooltip-id="my-tooltip"
                      data-tooltip-content={f.tooltip_content.text}
                    >
                      <i className="ml-2 fa-solid fa-circle-question opacity-30" />
                      <Tooltip id="my-tooltip" place="right" />
                    </a>
                  ) : (
                    ""
                  )}
                </div>
              </li>) : null
            );
          }
        })}
      </ul>
    </div>
  );
};
